import { HealthClaimCostItem } from '@models/HealthClaimCostItem';
import { handleActions } from 'redux-actions';
import {
  stateUpdate,
  healthClaimCostItemCreateSuccess,
  healthClaimCostItemUpdateSuccess,
  healthClaimCostItemDeleteSuccess,
  State,
  healthClaimUpdateSuccess
} from './action';

const initialState: State = {
  healthClaim: undefined,
  isUpdatingHealthClaim: false,
  serverErrors: {},
};

const reducer = handleActions(
  {
    [String(stateUpdate)]: (state, { payload }) => {
      return {
        ...state,
        ...payload,
      };
    },
    [String(healthClaimCostItemCreateSuccess)]: (state, { payload }) => {
      const { healthClaimCostItem } = payload as unknown as { healthClaimCostItem: HealthClaimCostItem };
      return {
        ...state,
        healthClaimCostItems: [
          ...(state.healthClaimCostItems ?? []),
          healthClaimCostItem
        ]
      };
    },
    [String(healthClaimCostItemUpdateSuccess)]: (state, { payload }) => {
      const { healthClaimCostItem } = payload as unknown as { healthClaimCostItem: HealthClaimCostItem };
      return {
        ...state,
        healthClaimCostItems: (state.healthClaimCostItems ?? []).map((item) => item.id === healthClaimCostItem.id ? healthClaimCostItem : item)
      };
    },
    [String(healthClaimCostItemDeleteSuccess)]: (state, { payload }) => {
      const { healthClaimCostItem } = payload as unknown as { healthClaimCostItem: HealthClaimCostItem };
      return {
        ...state,
        healthClaimCostItems: (state.healthClaimCostItems ?? []).filter((item) => item.id !== healthClaimCostItem.id)
      };
    },
  },

  initialState,
);

export default reducer;
